import { Component, Element, Host, Prop, h } from '@stencil/core'
import { type CobaltIcon } from '../../../cobalt-icon/cobalt-icon'

@Component({
  tag: 'cobalt-tab-panel'
})
export class CobaltTabPanel {
  @Element() el: HTMLElement

  /**
   * Label of the tab panel. It is **required**.
   */
  @Prop() label!: string
  /**
   * icon name from `@pollux-docaposte/icon-library`
   * Only the default icons have to be added. They will change automatically when tab is selected.
   */
  @Prop({ mutable: true }) iconName: Extract<CobaltIcon['name'], `${string}-outline`> = 'star-outline'
  /**
   * Adding a notification pill to the dedicated tab.
   * The property can be empty to display an empty notification pill
   */
  @Prop({ mutable: true }) notificationPillNumber: string = undefined
  /**
   * A boolean indicating the disable state of the tab.
   */
  @Prop({ mutable: true }) disabled: boolean = false

  render(): any {
    return (
      <Host label={this.label} disabled={this.disabled} iconName={this.iconName} notificationPillNumber={this.notificationPillNumber}>
        <div class="cobalt-tab-panel">
          <slot></slot>
        </div>
      </Host>
    )
  }
}
